import { forwardRef } from 'react';

import {
  Cell as RACCell,
  type CellProps as RACCellProps,
} from 'react-aria-components/Table';

import { cx } from '../../utils/cx';
import { alignStyles, type TableAlign } from './align';

import styles from './table_view.module.css';

export type CellProps = RACCellProps & {
  className?: string;
  slot?: string;
  fixedLeft?: boolean;
  fixedRight?: boolean;
  align?: TableAlign;
};

/**
 * Cell - A table cell containing data.
 */
export const Cell = forwardRef<HTMLTableCellElement, CellProps>(
  ({ align, className, children, ...props }, ref) => {
    return (
      <RACCell
        ref={ref}
        className={cx([
          styles.cell,
          { [styles.fixed_left]: props.fixedLeft },
          { [styles.fixed_right]: props.fixedRight },
          align ? alignStyles[align] : undefined,
          className,
        ])}
        {...props}
      >
        {children}
      </RACCell>
    );
  },
);
